export const convertPriceDisplay = (num: number) => {
	return `${num.toLocaleString()}円`;
};
